// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-light[data-v-4543a406]:disabled{background-color:transparent!important}", ""]);
// Exports
module.exports = exports;
